import React from 'react';
import CloseIcon from '@wix/da-ds/pkg/Icons/24x24/Close';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import ButtonB5 from '../../../Button/ButtonB5';
import { PapiDeviation } from '@wix/da-papi-types';
import { getDeviationResourceType } from '../../_helpers';
import {
  BiData,
  BiEvent,
  WatchItemRemoveClickBiEvent,
} from '@wix/da-bi/pkg/events';

interface Props {
  deviation: PapiDeviation;
  className?: string;
  biData?: BiEvent;
  onRemove: () => void;
}

const ThumbRemove: React.FC<Props> = ({
  deviation,
  className,
  biData,
  onRemove,
}) => {
  return (
    <div className={className}>
      <ButtonB5
        icon={CloseIcon}
        iconProps={{
          size: IconSize.MEDIUM,
        }}
        withBackground
        biData={BiData<WatchItemRemoveClickBiEvent>({
          ...biData,
          evid: 405,
          typeid: getDeviationResourceType(deviation),
          itemid: deviation.deviationId,
        })}
        onClick={onRemove}
      />
    </div>
  );
};
ThumbRemove.displayName = 'ThumbRemove';

export default ThumbRemove;
